// components/PermissionRoutes/PermissionRoutes.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { hasPermission, getPermissions } from "../../pages/Login/authUtils";
import Error404 from "../../pages/404Error/404Error";

const PermissionRoute = ({ children, permission, isPublic = false }) => {
  const isAuthenticated = localStorage.getItem("authenticated") === "true";
  const location = useLocation();
  const path = location.pathname;

  // 🟡 PUBLIC ROUTES
  if (isPublic) {
    return isAuthenticated ? <Navigate to="/" /> : children;
  }

  // 🔐 REQUIRE LOGIN
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  // ====== 🔧 DYNAMIC PERMISSION TRANSLATION ======
  let requiredPermission = permission;

  const getModelFromPath = () => {
    const parts = path.split("/").filter(Boolean);
    return parts[1] || "";
  };

  if (permission && permission.startsWith("table:")) {
    const action = permission.split(":")[1];
    const model = getModelFromPath().toLowerCase();

    if (model) {
      let actionSuffix = "view";

      if (action === "edit" || action === "create") {
        actionSuffix = "write";
      }

      requiredPermission = `${model}.${actionSuffix}`;
    }
  }

  // 🛡️ Permission check
  if (requiredPermission && !hasPermission(requiredPermission)) {
    return <Error404 />; // ❌ NO ACCESS → 404 PAGE
  }

  return children;
};

export default PermissionRoute;
